import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M7.5 5.625 5.625 7.5l6.77 6.77a1.326 1.326 0 1 0 1.876-1.874L7.5 5.625Zm-2.708-.833-.834.833m2.292.625L4.792 4.792 6.25 6.25ZM4.792 4.792l.833-.834-.833.834Zm9.791 9.791 1.459 1.459" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);